exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.well[data-v-1ba0fd89] {\n  margin-top: 20px;\n}\n", ""]);

// exports
